// ----------------------------------------------------------------------

import { Z_INDEX } from '../../constants/zIndex';

export default function Menu(theme) {
  return {
    MuiMenu: {
      styleOverrides: {
        paper: {
          zIndex: Z_INDEX.HEADER_DROPDOWN, // Ensure menus appear above other elements
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: theme.palette.action.selected,
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
          },
        },
      },
    },
  };
}
